import { render, staticRenderFns } from "./HorizontalList.vue?vue&type=template&id=d4e249a6&"
import script from "./HorizontalList.vue?vue&type=script&lang=js&"
export * from "./HorizontalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports